module.exports = __webpack_public_path__ + "static/media/empty-cart.3544d381.svg";